import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_SortingState,
  type MRT_PaginationState,
  MRT_ColumnDef, type MRT_TableOptions, MRT_EditActionButtons, MRT_Row,
} from 'material-react-table';
import {
  useUpdatePrevServElem,
  useGetPrevServElemDTOSumByPrev,
} from "./ServicesSE";
import {PrevCustElem, PrevServElemDTO} from "./types";
import React, { useEffect, useMemo, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material'
import PreventiviEditCEROW from "./PreventiviEditCEROW";
import PreventiviEditSEROW from "./PreventiviEditSEROW";

interface PreventiviSEProps {
  idprevprop: number;

}

const PreventiviEditSE: React.FC<PreventiviSEProps> = ({ idprevprop }) => {
  const [validationErrors, setValidationErrors] = useState<Record<string, string | undefined>>({});
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({ pageIndex: 0, pageSize: 15 });

  // const [resultsSum, setResultsSum] = useState({ sum_numanalisi: 0, sum_numconf: 0, sum_numform: 0, sum_numtot: 0 }); // State for results_sum




  const { data: { results = [], results_sum = [], count } = {}, isFetching: isFetchingPrevServElemDTOSumByPrev } = useGetPrevServElemDTOSumByPrev(pagination, [], globalFilter, sorting, idprevprop);

  const [currentRowId, setCurrentRowId] = useState<number | null>(null);
  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);

  const openEditModal = (row: MRT_Row<PrevServElemDTO>) => {
  setCurrentRowId(Number(row.original.id)); // ✅ real DB id
  setIsDialogEditOpen(true);
};


  const { mutateAsync: updatePrevServElem } = useUpdatePrevServElem();

  const handleSavePrevServElem: MRT_TableOptions<PrevServElemDTO>['onEditingRowSave'] = async ({ values, table }) => {
    const newValidationErrors = validatePrevServElem(values);
    if (Object.values(newValidationErrors).some
    ((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});

   const parseNum = (val: any) => parseFloat((val ?? '0').toString().replace(',', '.')) || 0;

    const numanalisi = parseNum(values.numanalisi);
    const numconf = parseNum(values.numconf);
    const numform = parseNum(values.numform);
    const numprep = parseNum(values.numprep);
    const numtot = numanalisi + numconf + numform;


    const myPrevServElem = {
      id: values.id,
      idprevtesta: values.idprevtesta,
      idservelem: values.idservelem,
      note: values.note,
      numprep,
      numanalisi,
      numconf,
      numform,
      numtot
    };

    // console.log("values", values);
    // console.log("myPrevServElem", myPrevServElem);

    await updatePrevServElem(myPrevServElem);
    table.setEditingRow(null); // exit editing mode
  };

  // const calculateTotals = (data: PrevServElemDTO[]) => {
  //   const totals = { numanalisi: 0, numconf: 0, numform: 0, numtot: 0, numprep: 0 };
  //   data.forEach((item) => {
  //     totals.numanalisi += parseFloat((item.numanalisi || '0').toString().replace(',', '.'));
  //     totals.numconf += parseFloat((item.numconf || '0').toString().replace(',', '.'));
  //     totals.numform += parseFloat((item.numform || '0').toString().replace(',', '.'));
  //     totals.numtot += parseFloat((item.numtot || '0').toString().replace(',', '.'));
  //     totals.numprep += parseFloat((item.numprep || '0').toString().replace(',', '.'));
  //   });
  //   return totals;
  // };

  // const [totals, setTotals] = useState(calculateTotals(results));
  //
  // useEffect(() => {
  //   if (results.length > 0) {
  //     setTotals(calculateTotals(results));
  //   }
  // }, [results]);

  const columns = useMemo<MRT_ColumnDef<PrevServElemDTO>[]>(() => [
    { accessorKey: 'id', header: 'Id', size: 30, enableEditing: false },
    { accessorKey: 'codarea', header: 'CodA', size:60, enableEditing: false },
    { accessorKey: 'desarea', header: 'Area', size: 100, enableEditing: false },
    { accessorKey: 'codmodulo', header: 'CodM', size: 60, enableEditing: false },
    { accessorKey: 'desmodulo', header: 'Modulo', size: 300, enableEditing: false },

     { accessorKey: 'numanalisi', header: 'Ana', size: 45, enableEditing: true, muiTableBodyCellProps: { align: 'right' }, muiTableFooterCellProps: { align: 'right' }, Footer: () => <Box>{results_sum[0].sum_numanalisi.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0}</Box>},
     { accessorKey: 'numconf', header: 'Con', size: 45, enableEditing: true, muiTableBodyCellProps: { align: 'right' }, muiTableFooterCellProps: { align: 'right' }, Footer: () => <Box>{results_sum[0].sum_numconf.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0}</Box>},
     { accessorKey: 'numform', header: 'For', size: 45, enableEditing: true, muiTableBodyCellProps: { align: 'right' }, muiTableFooterCellProps: { align: 'right' }, Footer: () => <Box>{results_sum[0].sum_numform.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0}</Box>},
     { accessorKey: 'numtot', header: 'Tot', size: 45, enableEditing: false, muiTableBodyCellProps: { align: 'right' }, muiTableFooterCellProps: { align: 'right' }, Footer: () => <Box>{results_sum[0].sum_numtot.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0}</Box> },


    { accessorKey: 'numprep', header: 'Prep', size: 45, enableEditing: true, muiTableBodyCellProps: { align: 'right' }, muiTableFooterCellProps: { align: 'right' } },
    // { accessorKey: 'note', header: 'Note', size: 350, grow: true, enableEditing: true, muiTableBodyCellProps: { align: 'left' }, muiTableFooterCellProps: { align: 'right' } },
{
  accessorKey: 'note',
  header: 'Note',
  size: 350,
  grow: true,

  Cell: ({ cell }) => {
    const value = cell.getValue<string>() ?? '';

    return (
      <Tooltip
        title={value}
        arrow
        placement="top-start"
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: 400,
              whiteSpace: 'pre-wrap',
              fontSize: '0.85rem',
            },
          },
        }}
      >
        <Box
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'help',
          }}
        >
          {value}
        </Box>
      </Tooltip>
    );
  },
  },


  ], [results_sum]);

  const table = useMaterialReactTable({
    columns,
    data: results,
    displayColumnDefOptions: { 'mrt-row-actions': { size: 40 } },
    layoutMode: 'grid',
    initialState: {
      density: 'compact',
      // columnVisibility: { idprevservelem: false, idprevtesta: false, idservelem: false },
    },
    enableRowSelection: false,
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableColumnFilterModes: false,
    enableColumnResizing: false,
    enablePagination: false,
    enableColumnVirtualization: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableToolbarInternalActions: false,
    enableEditing: true,
    editDisplayMode: 'modal',
    muiEditRowDialogProps: {
        open: true,
        maxWidth: "md", // Max width by breakpoint
        // slotProps:{
        //   paper: {
        //     sx: { maxWidth: 500 } // Max width in px
        //   }
        // }
      },
    enableTableHead: true,
    muiTableBodyRowProps: { hover: false },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: 'lightgrey',
        fontStyle: 'italic',
        fontSize: '0.8rem',
        fontWeight: 'bold',
      },
    },
    muiTableBodyCellProps: {
      style: {
        border: '1px solid rgba(81, 81, 81, .5)',
      },
    },
    muiTableFooterCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        color: 'red',
        align: 'right',
        fontWeight: 'bold',
        fontSize: '16px',
      },
    },
    getRowId: (row) => row.id,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSavePrevServElem,

     //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>

        {/*<DialogTitle variant="h3">Edit</DialogTitle>*/}
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem'}}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        {/*<Tooltip title="Edit">*/}
        {/*  <IconButton onClick={() => table.setEditingRow(row)}>*/}
        {/*    <EditIcon />*/}
        {/*  </IconButton>*/}
        {/*</Tooltip>*/}


       <Tooltip title="Modifica">
          <IconButton   onClick={() => openEditModal(row)} >
            <EditIcon />
          </IconButton>
        </Tooltip>




      </Box>
    )


  });

  if (isFetchingPrevServElemDTOSumByPrev || results_sum.length === 0) {
    return <div>Loading...</div>; // Or any loading spinner
  }

return (
       <>
    <MaterialReactTable table={table} />

    {isDialogEditOpen && currentRowId !== null && (
                          <PreventiviEditSEROW
                            open={isDialogEditOpen}
                            idprevservelemprop={currentRowId}
                            onClose={() => {
                              setIsDialogEditOpen(false);
                              setCurrentRowId(null);
                            }}
                          />
                        )}

      </>

  );
};

export default PreventiviEditSE;

const validateNumber = (value: any): boolean => {
  if (typeof value === 'number' && !isNaN(value)) {
    return true;
  }
  if (typeof value === 'string') {
    const normalizedValue = value.replace(',', '.');
    const parsedNumber = parseFloat(normalizedValue);
    return !isNaN(parsedNumber);
  }
  return false;
};

function validatePrevServElem(prevservelem: any) {
  return {
    numprep: !validateNumber(prevservelem.numprep) ? 'Valore numerico' : '',
  };
}
